document.addEventListener('DOMContentLoaded', function () {
    const hamburgerMenu = document.querySelector('.js--hamburger-menu');
    const drawerMenu = document.querySelector('.js--drawer-menu');
    const bodyInner = document.querySelector('.js--body-inner');

    if (!hamburgerMenu || !drawerMenu || !bodyInner) return;

    /**
     * メニューを開く処理
     */
    function openMenu() {

        const scrollPos = window.scrollY || window.pageYOffset || 0;
        bodyInner.dataset.scroll = String(scrollPos);

        bodyInner.classList.add('scroll-prevent');
        bodyInner.style.top = `-${scrollPos}px`;

        drawerMenu.setAttribute('aria-hidden', 'false');

        // -open クラス付与
        hamburgerMenu.classList.add('-open');
        drawerMenu.classList.add('-open');
    }

    /**
     * メニューを閉じる処理
     */
    function closeMenu() {

        bodyInner.classList.remove('scroll-prevent');
        bodyInner.style.top = '0px';

        const savedScroll = Number(bodyInner.dataset.scroll || 0);
        window.scrollTo(0, savedScroll);

        drawerMenu.setAttribute('aria-hidden', 'true');

        // -open クラス削除
        hamburgerMenu.classList.remove('-open');
        drawerMenu.classList.remove('-open');
    }

    hamburgerMenu.addEventListener('click', function() {
        if (hamburgerMenu.classList.contains('-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    drawerMenu.addEventListener('click', function(e) {
        if (e.target === drawerMenu || e.target.closest('.slide-nav__link')) {
            closeMenu();
        }
    });
});